import { useTheme } from '@/shared/hooks/useTheme';
import { versionedPublicAssetUrl } from '@/shared/lib/publicAssetUrl';

const lightLogoUrl = versionedPublicAssetUrl('sshop-logo-light.png');
const darkLogoUrl = versionedPublicAssetUrl('sshop-logo-dark.png');

interface BrandProps {
  readonly className?: string;
  readonly size?: 'sm' | 'md';
}

const SIZE: Record<NonNullable<BrandProps['size']>, string> = {
  sm: 'h-10',
  md: 'h-10 sm:h-12',
};

export function Brand({ className, size = 'md' }: BrandProps) {
  const { resolvedTheme } = useTheme();
  const logoUrl = resolvedTheme === 'dark' ? darkLogoUrl : lightLogoUrl;

  return (
    <span className={['inline-flex items-center', className ?? ''].join(' ')}>
      <img
        src={logoUrl}
        alt="SSHOP.GE"
        className={`${SIZE[size]} w-auto select-none`}
        draggable={false}
        decoding="async"
      />
    </span>
  );
}
